import { APP_MENU, MenuItem } from './menu.config';

type Layout = 'SECRETARIA' | 'SECRETARIA-B' | 'CLASSROOMS';

type CONFIG = {
  title: string;
  description: string;
  layout: Layout;
  menu: Record<string, MenuItem[]> | any;
  routes: Record<string, string> | any;
  conventions: Record<string, string> | any;
  swr: Record<string, string> | any;
  liveImagePath: string;
};

const APP_CONFIG: CONFIG = {
  // META
  title: 'Secretaria Graduação',
  description: 'CMS (Admin) para operações Pedagógicas e Acadêmicas da Faculdade Descomplica',

  // LAYOUT
  layout: 'SECRETARIA-B',

  // MENU
  menu: APP_MENU,

  // ROUTES
  routes: {
    HOME_URL: '/',
    BACKOFFICE_ADMIN_URL: 'https://secretaria.descomplica.com.br/',
    CUSTOMER_SERVICE_URL: 'https://no.descomplica.com.br/knowledge/gradua%C3%A7%C3%A3o',
    USER_PROFILE_URL: 'https://alumni.descomplica.com.br/',
  },

  // CONVENTIONS
  conventions: {
    DEFAULT_USER_NAME: 'Aluno do Descomplica',
    DEFAULT_PAGE_SIZE: 20,
  },

  // SWR
  swr: {
    DEFAULT_CONFIG: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  },

  liveImagePath: 'landings/images/',
};

export default APP_CONFIG;
